import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a460ab48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "main" }
const _hoisted_2 = { id: "center" }
const _hoisted_3 = { id: "bottom" }




export default /*#__PURE__*/_defineComponent({
  __name: 'dialogCom',
  props: {
    title: null,
    show: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    title: string;
    show: boolean;
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "dialog",
    class: _normalizeClass({ show: props.show })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, _toDisplayString(props.title), 1),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "center")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "bottom")
      ])
    ])
  ], 2))
}
}

})